module.exports = __webpack_public_path__ + "img/loans.4d7450a.svg";